import styled from 'styled-components';

import { LinkButton as BaseLinkButton } from 'components/link-button';
import { primitive } from 'styles/constants/primitives';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: ${primitive.$spacing4};
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
  justify-content: space-between;
  margin-top: ${primitive.$spacing1};
  margin-bottom: ${primitive.$spacing1};
`;

export const LinkButton = styled(BaseLinkButton)`
  font-family: ${Styles.fontFamily.body};
  color: ${primitive.th.$alwaysRed};
  font-size: 0.813rem;
  line-height: 1.125rem;
  text-align: left;
  padding: 0;
`;

export const Title = styled.span`
  color: ${primitive.th.$coffeeBrown};
  font-family: ${Styles.fontFamily.body};
  font-weight: bold;
  font-size: 0.875rem;
  line-height: 1.25rem;
`;

export const Content = styled.span`
  font-family: ${Styles.fontFamily.body};
  color: ${primitive.th.$coffeeBrown};
  font-size: 0.875rem;
  line-height: 1.25rem;
  margin-right: ${primitive.$spacing6};
`;

export const PointsLabel = styled.span`
  font-family: ${Styles.fontFamily.body};
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: bold;
  color: ${primitive.th.$alwaysRed};
  white-space: nowrap;
`;

export const SkeletonLeftContentWrapper = styled.div`
  width: 100%;
`;

export const SkeletonRightContentWrapper = styled.div`
  width: 100%;
  text-align: right;
`;
